import type { AvailableCountries, AvailableLanguages } from './users.types';

// OrganizationRole enum (used in both Organization and Invitation schemas)
export enum OrganizationRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}

// WorkspaceMemberRole enum for invitation API
export enum WorkspaceMemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

// TODO: probably we need to create a new clients type or put at the existed
export enum ClientsInvitationStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  CANCELED = 'canceled',
}
export enum InvitationStatus {
  SENT = 'sent',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
  EXPIRED = 'expired',
}

// it is not very using now but don't touch while developing workspaces/organisation
interface IOrganizationMember {
  _id: string; // ObjectId, ref 'Accountant', required
  email: string; // required
  role: OrganizationRole; // enum, required
  invitedAt?: Date | string;
  joinedAt: Date | string; // required
  // Note: _id: false, id: false in schema
}

// possibly we will use it for stripe
interface IOrganizationSubscription {
  plan_internal_name: string;
  from_platform: string;
  seats_price_id: string;
  seats_subscription_id: string;
  seats_count: number;
  start: Date | string;
  end: Date | string | 'INFINITE';
  status: {
    valid?: boolean;
    auto_renew?: boolean;
    did_refund?: boolean;
    cancellation_reason?: string;
    retry_period_end?: Date | string;
    in_retry_period?: boolean;
  };
  created?: Date | string;
  updated?: Date | string;
  // Note: _id: false, id: false in schema
}

// Organization schema (main document)
interface IOrganization {
  _id: string;
  name: string;
  email: string; // required, lowercase, trim
  country: AvailableCountries;
  language: AvailableLanguages;
  address?: {
    street?: string; // maxLength: 255
    postal_code?: string; // maxLength: 20
    city?: string; // maxLength: 100
  };
  phone_number?: string;
  ITAA_Number?: string;
  references?: {
    chift_customer_id?: string;
    stripe_customer_id?: string;
  };
  members: IOrganizationMember[];
  subscription?: IOrganizationSubscription;
  created: Date | string;
  modified: Date | string;
}

// OrganizationInvitation schema (separate collection)
interface IOrganizationInvitation {
  _id: string;
  organizationId: string;
  email: string;
  token: string;
  role: OrganizationRole;
  status: InvitationStatus;
  created: Date | string;
  respondedAt?: Date | string | null;
}

// API response types for organization-related endpoints
export interface CreateOrganizationRequest {
  name: string;
  email: string;
  country: AvailableCountries;
  language: AvailableLanguages;
  address?: {
    street?: string;
    postal_code?: string;
    city?: string;
  };
  phone_number?: string;
  ITAA_Number?: string;
}

export interface OrganizationResponse {
  message: string;
  // Note: API calls it 'workspace' because in the future we will have split workspaces and organizations
  organisation: IOrganization;
}

// New invitation API types
export interface InviteMembersRequest {
  email: string;
  redirect_path?: string;
  redirect_uri?: string;
  role?: WorkspaceMemberRole;
}

// TODO: move to workspace
export interface InviteMembersResponse {
  ok: boolean;
  message: string;
  invitation?: IOrganizationInvitation; // TODO: define invitation entity type when available
}
